import { render, staticRenderFns } from "./accountDetail.vue?vue&type=template&id=a16aaae4&scoped=true&"
import script from "./accountDetail.vue?vue&type=script&lang=js&"
export * from "./accountDetail.vue?vue&type=script&lang=js&"
import style0 from "./accountDetail.vue?vue&type=style&index=0&id=a16aaae4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16aaae4",
  null
  
)

export default component.exports